export default __webpack_public_path__ + "static/BMW X5M-1c6bdd83d7b126c406f3c4246e30f82d.jpg";